import React from "react";

const CloseDocumentModal = ({
  docLabel,
  selectedRowData,
  f5InputValue,
  setF5InputValue,
  handleF5Submit,
  f5Loading,
  onClose,
}) => {
  return (
    <div className="space-y-4 p-6">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Document Number
        </label>
        <input
          type="text"
          value={
            selectedRowData?.["DO NO"] ||
            selectedRowData?.["SO NO"] ||
            selectedRowData?.["QUOT NO"] ||
            selectedRowData?.["PO NO"] ||
            ""
          }
          disabled
          className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-100 text-gray-600"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Comments <span className="text-red-500">*</span>
        </label>
        <textarea
          value={f5InputValue}
          rows={3}
          onChange={(e) => setF5InputValue(e.target.value)}
          placeholder="Enter comments here..."
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          autoFocus
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault();
              handleF5Submit();
            }
          }}
        />
      </div>
      <div className="flex gap-3 pt-2">
        <button
          onClick={handleF5Submit}
          disabled={f5Loading || !f5InputValue.trim()}
          className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          {f5Loading ? "Processing..." : `Close ${docLabel}`}
        </button>
        <button
          onClick={onClose}
          disabled={f5Loading}
          className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 disabled:opacity-50 transition-colors"
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default CloseDocumentModal;
